import Table from 'antd/es/table';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  &&& {
    .actions-hover-reveal {
      visibility: hidden;
    }
    .ant-table-thead > tr > th {
      font-family: var(--font-bold);
      font-size: 12px;
      background-color: transparent;
      color: var(--text-primary);
    }
    .ant-table-tbody > tr:nth-child(odd) {
      background-color: inherit;
    }
    .ant-table-tbody > tr > td {
      padding: 11px;
    }
    .ant-table-cell-with-append {
      display: flex;
    }
    .ant-table-cell-row-hover {
      .actions-hover-reveal {
        visibility: visible;
      }
    }
    .ant-table-pagination {
      padding: 0px 24px;
      margin: 22px 0px;
      align-items: baseline;
      font-size: 12px;

      .ant-pagination-total-text {
        position: absolute;
        right: 20px;
      }

      .ant-pagination-item {
        line-height: 24px;
        color: var(--text-primary);
      }

      .ant-pagination-item-active {
        border-radius: 11px;

        box-shadow: 0 2px 6px 0 var(--box-shadow-gray);
        background-color: #fff;
        border: none;
        a {
          color: var(--text-primary) !important;
        }
      }
    }
  }
`;
